import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

import breakpoints from '../utils/breakpoints';
import { setAriaLabelledBy } from '../utils/dom';
import { getGenericSliderConfig } from '../utils/slider';

class CardRow extends Component {
  postSetup() {
    this.dom = {
      $heading: this.el._$('h2'),
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container')
    };

    this.stackedCards = this.el.dataset.stackedCards;

    this.initSlider();
    this.labelCards();
  }

  setupDefaults() {
    this.dataFlag = this.el.dataset.flagLw ? this.el.dataset.flagLw.toLowerCase() === 'true' : false;

    // Set an interval to check for a condition until it applies, then clear the interval
    const checkCondition = () => {
      // Check if .swiper-slide exists in this.el
      const slidesExist = this.el._$$('.swiper-slide').length > 0;
      return slidesExist;
    };

    // Use window.setInterval and window.clearInterval to avoid linter errors
    if (this.dataFlag) {
      const intervalId = window.setInterval(() => {
        if (checkCondition()) {
          window.clearInterval(intervalId);
          this.postSetup();
        }
      }, 1000);
    } else {
      this.postSetup();
    }
  }

  initSlider() {
    const { $swiperContainer, $slides, $heading } = this.dom;
    const { length } = $slides;

    function getSlidesLg() {
      if (length > 1) {
        if (length > 2) {
          return 3;
        }
        return length;
      }

      return 2;
    }

    /* eslint-disable indent */
    const additionalOptions = this.stackedCards
      ? {
          slidesPerColumn: 10,
          slidesPerColumnFill: 'row',
          allowTouchMove: false
        }
      : {};
    /* eslint-enable indent */

    // const rowOptions = this.maxPerRow
    //   ? {
    //       slidesPerView: 3,
    //       slidesPerColumn: 2,
    //       slidesPerColumnFill: 'row',
    //       allowTouchMove: false
    //     }
    //   : {};

    const element = this.el;

    this.swiper = new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, $heading),
      slidesPerView: 1,
      spaceBetween: 25,
      observer: true,
      observeParents: true,
      breakpoints: {
        [breakpoints.tablet]: {
          spaceBetween: 20,
          slidesPerView: this.el.closest('.big-wrapper') ? 2 : 3
        },
        [breakpoints.md]: {
          spaceBetween: 10,
          slidesPerColumn: 1
        },
        [breakpoints.lg]: {
          centeredSlides: length === 1,
          slideToClickedSlide: false,
          spaceBetween: 10,
          slidesPerView: getSlidesLg(),
          ...additionalOptions
          // ...rowOptions
        }
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        }
      }
    });
  }

  labelCards() {
    const { $slides } = this.dom;
    $slides.forEach(($slide) => {
      const $article = $slide._$('article');
      const $heading = $article?._$('h3');

      if ($article && $heading) {
        setAriaLabelledBy($article, $heading);
      }
    });
  }
}

export default CardRow;
